import auth from "@/auth/authService";

export default {
    isUserLoggedIn: () => {
      let isAuthenticated = false
      if(localStorage.getItem('userInfo') != '' && localStorage.getItem('accessToken') != ''){
        isAuthenticated = true
      }
    }
}
